class S1Error extends Error {
    statusCode: number
    message: string

    constructor(statusCode: number, message: string) {
        super(message)
        this.statusCode = statusCode
        this.message = message
    }
}

export default S1Error
